/**
 * TICKET P5-C §1: einzige Quelle der deutschen Beschriftungen für die
 * Beauftragungsart (`Order.commissionType`). Die Enum
 * (GWH_BEAUFTRAGUNG | MIETERDIREKT | SONSTIGE) stammt aus dem generierten
 * Client; die Labels bleiben hier zentral, damit Auftragsanlage, -detail und
 * der Vorgangs-Reiter dieselben Texte zeigen.
 */
import { OrderCreateDtoCommissionType } from '@werkbank/shared';

export const COMMISSION_TYPE_LABELS: Record<string, string> = {
  GWH_BEAUFTRAGUNG: 'GWH-Beauftragung',
  MIETERDIREKT: 'Mieterdirektbeauftragung',
  SONSTIGE: 'Sonstige',
};

/** Standard-Beauftragungsart, wenn nichts gewählt wurde (Migration/Default). */
export const DEFAULT_COMMISSION_TYPE = OrderCreateDtoCommissionType.SONSTIGE;

/** Rohwert → Label mit Fallback auf den Rohwert (falls je ein Wert hinzukommt). */
export function commissionTypeLabel(value: string | null | undefined): string {
  if (!value) return '';
  return COMMISSION_TYPE_LABELS[value] ?? value;
}

/** Select-Optionen in fachlicher Reihenfolge (Sonstige zuletzt = Default). */
export const COMMISSION_TYPE_OPTIONS: { value: string; label: string }[] = [
  OrderCreateDtoCommissionType.GWH_BEAUFTRAGUNG,
  OrderCreateDtoCommissionType.MIETERDIREKT,
  OrderCreateDtoCommissionType.SONSTIGE,
].map((value) => ({ value, label: commissionTypeLabel(value) }));
